export default __webpack_public_path__ + "static/media/sensotrend_uploader_scroll.28046973.png";